import errorHandle from '../../../utils/errorHandle';
import { supOrgTripDetailsFun, supTripOrgDateFun } from '../../../api/supportAdmin';

export default async function fetchSupOrgTripData(setLoading, setPackData, setDates, serviceType) {
    setLoading(true);
    const packId = window.location.pathname.split('/')[5];
    try {
        //search result filter olage price range band data is reseting
        //search result api on change min and max price should go
        // for getDateDetailsFun you get an array of objects with tripDate id, start and end date of each
        const allData = await Promise.all([
            await supOrgTripDetailsFun(packId, serviceType),
            await supTripOrgDateFun(packId, 'trip', 'next')
        ]);
        const sortedDates = allData[1].data.sort((a, b) => new Date(a.startDate) - new Date(b.startDate));
        setPackData(allData[0].data);
        setDates(sortedDates);
        setLoading(false);
    } catch (error) {
        setLoading(false);
        errorHandle(error);
    }
}

export async function fetchPackData(id, setLoading, setData, serviceType) {
    setLoading(true);
    try {
        const result = await supOrgTripDetailsFun(id, serviceType);
        // the API returns the listing object (older versions sent [listing])
        setData((Array.isArray(result.data) ? result.data[0] : result.data) || {});
        setLoading(false);
    } catch (error) {
        errorHandle(error);
        setLoading(false);
    }
}
